import { render } from "./DeliveryCompanyGeneralInformation.vue?vue&type=template&id=a10b204c&scoped=true"
import script from "./DeliveryCompanyGeneralInformation.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanyGeneralInformation.vue?vue&type=script&lang=js"

import "./DeliveryCompanyGeneralInformation.vue?vue&type=style&index=0&id=a10b204c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10b204c"]])

export default __exports__